import { Injectable } from '@angular/core';
import { UserDataService } from './data.users.service';
import { MemberDataService } from './data.members.service';
import { SchoolDataService } from './data.schools.service';
import { TeacherDataService } from './data.teachers.service';
import { EmailTplDataService } from './data.emailtpls.service';
import { Subject } from 'rxjs'

import { SharedDataService } from './data.shared.service';


import * as dpConfig from '../config/datepicker.config';

@Injectable()
export class DataService {
	public constructor(
		private userData: UserDataService,
		private memberData: MemberDataService,
		private schoolData: SchoolDataService,
		private teacherData: TeacherDataService,
		private emailTplData: EmailTplDataService,
		private sharedData: SharedDataService

	) { }

	public user = this.userData;
	public member = this.memberData;
	public school = this.schoolData;
	public teacher = this.teacherData;
	public shared = this.sharedData;
	public emailtpl = this.emailTplData;
	public tmpData = {
		selectedEditPartRecord: null
	}
	

	// common
	public datepicker = dpConfig;
	

}



// WEBPACK FOOTER //
// ./src/services/data.service.ts